import "@fpsm/cxy-tokens/tokens.css?__remix_sideEffect__";

import HeaderDesktop from './components/HeaderDesktop';
import HeaderMobile from './components/HeaderMobile';

export const HeaderV2 = () =>
<>
		<HeaderMobile />
		<HeaderDesktop />
	</>;